import { createContext } from "react";



const initialState = {
    form: null,
    dataConcluded: {
        analysis: [],
        comments: [],
        quotation: [],
        tableData: [],
        isEditForm: false,
        isOvertimeComments: false
    },
    optionRadio: true,
    selectedTab: 0,
};

export const FormConcluedContext = createContext({
    ...initialState,
    updateQuatition: () => { },
    actionsComments: {
        updateComment: async () => { },
        deleteComment: async () => { },
    },
    fieldCheck: {
        checkAll: [],
        updateRefChecked: () => { },
        onChangueSelectAll: () => { }
    },
    fieldButton: {
        buttonsCheked: [],
        updateButtonsByForm: () => { },
        updateButtons: () => { }
    },

});


